import {
  Button,
  Flex,
  Heading,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { BsThreeDots } from 'react-icons/bs';
import { usePermissions } from 'shared/hooks/usePermissions';
import { Contract } from 'shared/models/contract';
import { useFinancialContext } from '../../FinancialContext';
interface ContractsHeaderProps {
  contracts: Contract[];
}
const ContractsHeader = ({ contracts = [] }: ContractsHeaderProps) => {
  const { e } = usePermissions();
  const {
    openCreateContractModal,
    openResellerContractModal,
    openChangeManyDueDateModal,
    openChangeManyPaymentMethodModal,
  } = useFinancialContext();

  const isReseller = e('reseller-create');

  const ContractsCount = contracts.length > 0 && (
    <Text size="medium" variant="headingCount">
      ({String(contracts.length).padStart(2, '0')})
    </Text>
  );
  return (
    <HStack justify={'space-between'} w="100%">
      <Flex align="center" gap="8px">
        <Heading size="small" variant="yooga">
          Contratos
        </Heading>
        {ContractsCount}
      </Flex>

      <Flex gap="8px">
        <Menu variant="actions">
          <MenuButton
            as={Button}
            size="medium"
            leftIcon={<BsThreeDots />}
            variant="regular"
            color="yPrimary.600"
          >
            Ações
          </MenuButton>
          <MenuList>
            <MenuItem
              onClick={
                isReseller ? openResellerContractModal : openCreateContractModal
              }
            >
              Adicionar contrato
            </MenuItem>
            <MenuItem onClick={openChangeManyDueDateModal}>
              Alterar vencimento em lote
            </MenuItem>
            <MenuItem onClick={openChangeManyPaymentMethodModal}>
              Alterar método de pagamento em lote
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </HStack>
  );
};
export default ContractsHeader;
